



















































import { ResumoDaVenda, Venda } from '@/models'
import { TipoDeEnvioDeEmail } from '@/models/email/EnvioDeEmail'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { EditarUmaVendaUseCase, EmailUseCase } from '@/usecases'
import { avisarErroDeEnvioDeEmail, MENSAGEM_DE_EMAIL_EM_ENVIO } from '@/shareds/envio-de-email-shareds'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'

@Component
export default class DialogoDeInformarEmail extends Vue {
	@Ref() form!: HTMLFormElement

	mostra: boolean | null = false
	venda: Venda | ResumoDaVenda | null = null
	tipo: TipoDeEnvioDeEmail = 'NOTA_DA_VENDA'
	emailInformado: string | null = null
	emailRules = [
		(v: any) => !!v || 'E-mail é obrigatório',
		(v: any) => /.+@.+\..+/.test(v) || 'E-mail precisa ser válido',
	]
	loading = false

	editarUmaVendaUseCase = new EditarUmaVendaUseCase()

	mostrar(venda: Venda | ResumoDaVenda, tipo: TipoDeEnvioDeEmail = 'NOTA_DA_VENDA') {
		this.mostra = true
		this.venda = venda
		this.tipo = tipo
	}

	fechar(){
		this.mostra = false
	}

	async informarEmail() {
		if (!this.venda) return
		if (!this.emailInformado) return

		try {
			this.loading = true
			if (this.tipo === 'VALE_PRESENTE') {
				await new EmailUseCase().enviarValesPorEmail(this.venda.id, this.emailInformado)
			} else {
				await this.editarUmaVendaUseCase.enviarEmail(this.venda.id, this.emailInformado)
			}

			AlertModule.setSuccess(MENSAGEM_DE_EMAIL_EM_ENVIO)
		} catch(error) {
			avisarErroDeEnvioDeEmail(error)
		} finally {
			this.loading = false
			this.mostra = false
			this.emailInformado = null
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean, mostraAnterior: boolean) {
		if (mostra && !mostraAnterior) {
			window.requestAnimationFrame(() => {
				this.form.resetValidation()
			})
		}
	}

}
